import { DocumentUploaderItem } from '@app/shared/types/sf-data'
import {
  ExtraDocumentLinkTypes,
  LastOCRRequestParamsByAccountId,
  LastOCRRequestParams,
  ProposedDocument,
} from './types'

export const isLastOCRRequestParamsByAccountId = (
  params: LastOCRRequestParams
): params is LastOCRRequestParamsByAccountId => {
  return (params as LastOCRRequestParamsByAccountId).accountId !== undefined
}

export const isProposedDocument = (
  doc: DocumentUploaderItem | ProposedDocument
): doc is ProposedDocument => {
  return doc.linkType === ExtraDocumentLinkTypes.ProposedDocument
}

export const isNotProposedDocument = (
  doc: DocumentUploaderItem | ProposedDocument
): doc is DocumentUploaderItem => {
  return doc.linkType !== ExtraDocumentLinkTypes.ProposedDocument
}
